exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menu_task_form[data-v-7dca228c] {\n  display: contents;\n}\n.container_task[data-v-7dca228c] {\n  display: flex;\n  justify-content: right;\n}\n.container_nav_page[data-v-7dca228c] {\n  display: flex;\n  justify-content: center;\n}\n.sub_menu[data-v-7dca228c] .el-submenu__title {\n  height: 40px;\n  display: flex;\n  align-items: center;\n  border-radius: 4px;\n}\n.sub_menu[data-v-7dca228c] i {\n  color: #FFFFFF;\n  margin-top: 0 !important;\n}\n.name_device[data-v-7dca228c] {\n  cursor: pointer;\n}\n.name_device[data-v-7dca228c]:hover {\n    color: #00a1ff;\n}\n", ""]);

// exports
